module.exports = __webpack_public_path__ + "img/account-sets-gray.ce4f5436.svg";